import { trackPromise } from 'react-promise-tracker';

export async function registerCandidate(IDCampana, IDCandidato, userToken) {

   
    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/registrarcandidato', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': userToken
        },
        body: JSON.stringify({"IDCampana": IDCampana, "IDCandidato":  IDCandidato})
    }).then(data => data.json()))
}